import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-air-quality-detail-report',
  templateUrl: './air-quality-detail-report.component.html',
  styleUrls: ['./air-quality-detail-report.component.scss']
})
export class AirQualityDetailReportComponent implements OnInit {
public myDate=new Date();
  constructor() { }

  ngOnInit(): void {
  }

}
